<template>
	<div>		
		<v-form
		id="editInstructionForm"
		class="pa-5" 
		ref="form">
		<v-text-field
		v-model="instruction.name"
		label="Instruction Name"
		></v-text-field>	
		<v-textarea
		v-model="instruction.text"
		label="Instruction Text"
		></v-textarea>
		<v-textarea
		v-model="instruction.intro"
		label="Intro"
		></v-textarea>	
		<v-btn
		color="success"
		class="mr-4"
		@click="save"
		>Save
		</v-btn>
		</v-form> 
	</div>
</template>

<script>

export default {
  name: 'EditInstruction',
  props: ["instruction"],
  data: () => ({
    }),
	methods: {
		save() {
			var self = this;
			let update = {};
			for( var key in self.instruction ){
				update[key] = self.instruction[key];	
			}
			self.$store.dispatch("updateDoc", {
				action: "update", 
				data: update, 
				doc: "instructions/" + self.instruction.id
			}).then( function(){
				self.$emit("saved");
			}) 
		}
	}
};

</script>
